

<!-- Modal Start -->

 <!-- The Modal -->
 <div class="modal fade" id="myModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
      
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title badge badge-danger">Warning Message!</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        
        <!-- Modal body -->
        <div class="modal-body">
          Already Cart is Empty Please Select Product's..
        </div>
        
        <!-- Modal footer -->
        <div class="modal-footer">        
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
        
      </div>
    </div>
  </div>
  
  
  <!-- Modal end -->
  